import Vue from 'vue';
import Vuex from 'vuex';
import { ui } from './modules/ui/uiStore.js';
import { autoClaim } from './modules/auto-claim/autoClaimStore.js';

Vue.use(Vuex); //wweaa

const modules = {
    ui,
    autoClaim,
};

Object.keys(modules).forEach(key => {
    modules[key]['namespaced'] = true;
});

const store = new Vuex.Store({
    modules: {
        ...modules,
    },
});

export { store };
